import { render } from "./BaseSelect.vue?vue&type=template&id=0059fe7d&ts=true"
import script from "./BaseSelect.vue?vue&type=script&lang=ts"
export * from "./BaseSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__